import classes from "./Toggle.module.scss";

export default function Toggle({ isOn = false, handleToggle, label, className }) {
  return (
    <div className={`${classes.toggleContainer} ${className}`}>
      {label && <span className={classes.switchLabel}>{label}</span>}
      <label className={classes.switch}>
        <input
          type="checkbox"
          className={classes.switchInput}
          checked={isOn}
          onChange={handleToggle}
        />
        <span className={classes.switchSlider}></span>
      </label>
    </div>
  );
}
